import { Category as EdgeCategory } from 'generated/graphql';
import { Category } from '@modules/common/types';

export const mapEdgeCategoryToCategory = (category?: EdgeCategory) => {
  switch (category) {
    case EdgeCategory.Issue:
      return Category.Complaint;
    case EdgeCategory.Help:
      return Category.Help;
    case EdgeCategory.Improvement:
      return Category.Improvement;
    case EdgeCategory.Praise:
      return Category.Praise;
  }
};
